import PrivateRoute from './PrivateRoute.container'

export default PrivateRoute
